module.exports = __webpack_public_path__ + "img/password.f286e536.svg";